import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { routes } from 'router/routesConfig';
import { gaEventTracking, trackingConstant } from 'utils/analytics';
import { getCurrentRoute, serialize } from 'utils/commonFunctions';
import { menu } from 'utils/config';
import { ICONS, TRACKING_ELEMENT_ID } from 'utils/constants';

const Navbar = () => {
  const { pathname, state } = useLocation();

  const constants = {
    '': trackingConstant.HOME_TAB_CLICKED,
    '/': trackingConstant.HOME_TAB_CLICKED,
    leaderboard: trackingConstant.LEADERBOARD_TAB_CLICKED,
    rules: trackingConstant.RULES_TAB_CLICKED,
    game: trackingConstant.BACK_TO_HOME_FROM_QUIZ,
    result: trackingConstant.BACK_TO_HOME_FROM_RESULT
  };

  const handleLinkClick = (trackEvent) => () => {
    gaEventTracking(trackEvent);
  };

  const currentRoute = getCurrentRoute(pathname);

  const pageActions = {
    isLbPage: {
      headerText: 'Back',
      headerTrackingAction: () => {
        handleLinkClick(constants['leaderboard'])();
      },
      headerBckAction: () => {
        return routes.leaderboardLanding;
      }
    }
  };

  return (
    <div className='si-menu'>
      <div className='si-container'>
        <nav>
          {/* This will only be visible for the gameplay and result screen */}
          {['', '/', 'leaderboard', 'rules'].includes(currentRoute) ? (
            <ul className='si-menu__list'>
              {/* This will only be visible on the landing screen */}
              {menu().map(
                (item, idx) =>
                  item.displayOnNav && (
                    <Link
                      to={item.route}
                      key={idx}
                      id={TRACKING_ELEMENT_ID}
                      onClick={handleLinkClick(constants[item.route])}
                    >
                      <li className={currentRoute === item.route ? 'si-active' : ''}>
                        {item.name}
                      </li>
                    </Link>
                  )
              )}
            </ul>
          ) : (
            <Link
              className='si-menu__back'
              to={Object.keys(state).includes('isLbPage') ? routes.leaderboardLanding : routes.home}
              id={TRACKING_ELEMENT_ID}
              onClick={handleLinkClick(serialize(constants['']))}
            >
              <i className={ICONS.BACK_ARROW}></i>
              <span>
                {Object.keys(state).includes('isLbPage')
                  ? pageActions['isLbPage']?.headerText
                  : 'Back to home'}
              </span>
            </Link>
          )}
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
